import '../../core/components/app-root/AppRoot.css';
import './DetailView.css';
export var content = '_wapl5d1-3-8-0';
export var details = '_wapl5d0-3-8-0';